import React from 'react';

interface Feature {
  icon: string;
  title: string;
  description: string;
}

interface FeatureGridSectionProps {
  title: string;
  subtitle: string;
  badgeText: string;
  features: Feature[];
  theme?: 'default' | 'alternative';
}

export const FeatureGridSection: React.FC<FeatureGridSectionProps> = ({
  title,
  subtitle,
  badgeText,
  features,
  theme = 'default',
}) => {
  const sectionBg = theme === 'default' ? 'bg-white' : 'bg-gray-50';
  const iconBg = theme === 'default' ? 'bg-red-100' : 'bg-blue-100';
  const iconColor = theme === 'default' ? 'text-red-600' : 'text-blue-600';
  const badgeColor = theme === 'default' ? 'text-red-600' : 'text-blue-600';
  
  return (
    <section className={`py-20 ${sectionBg}`}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-2 mb-6">
            <i className={`ri-star-line ${badgeColor} text-2xl`}></i>
            <span className={`${badgeColor} font-semibold text-lg`}>{badgeText}</span>
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            {title}
          </h2>
          
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            {subtitle}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className={`w-16 h-16 ${iconBg} rounded-full flex items-center justify-center mb-6`}>
                <i className={`${feature.icon} ${iconColor} text-2xl`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              
              <p className="text-gray-700 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};